
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exhibition/association",
      function () {
        return require("private-next-pages/exhibition/association/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/exhibition/association"])
      });
    }
  